import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { PLAN_STEPS, WITHOUT_PLAN } from '../../data/catio';

/** Problem + process in one compact story: guesswork vs. a five-step plan. */
export function PlanSection() {
  return <section aria-labelledby="plan-title" className="bg-ivory py-12 sm:py-20" data-id="element-256" data-mp="16xlqbd713x80">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-257" data-mp="1bv44pj3tf4ne">
        <SectionHeading id="plan-title" title="Spend Less Time Starting Each Design from Zero" data-id="element-258" data-mp="f5wdpvkfg3c3" />

        <div className="mt-8 grid gap-3 sm:mt-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-5" data-id="element-259" data-mp="j6q6p3cq88bu">
          <div className="flex flex-col rounded-[16px] border border-line bg-paper px-5 py-5 sm:px-7 sm:py-7" data-id="element-260" data-mp="o62ovasnkr83">
            <h3 className="label-tech text-graphite" data-id="element-261" data-mp="sxkuic5mffze">Starting from scratch</h3>
            <p className="mt-3 font-display text-[2.5rem] leading-none text-ink/30 line-through decoration-ember decoration-2 sm:text-[3.2rem]" data-id="element-262" data-mp="3rnl07s7mwgd9">
              Scratch
            </p>
            <p className="mt-3 text-[0.98rem] leading-relaxed text-graphite" data-id="element-263" data-mp="210339f5ph95j">{WITHOUT_PLAN}</p>
          </div>

          <div className="rounded-[16px] bg-ink px-5 py-5 text-cream sm:px-7 sm:py-7" data-id="element-264" data-mp="1wyrch6b3ihvr">
            <h3 className="label-tech text-ember-light" data-id="element-265" data-mp="1s7st1xut93oa">Starting with CATIO READY™</h3>
            <ol className="relative mt-4 grid gap-1 lg:mt-6 lg:grid-cols-5 lg:gap-4" data-id="element-266" data-mp="1s5g1csz93ey1">
              <span className="absolute bottom-5 left-[15px] top-5 w-px bg-wood/50 lg:hidden" aria-hidden data-id="element-267" data-mp="1n8fx8nlyom9k" />
              {PLAN_STEPS.map((step, index) => <li key={step.title} className="relative flex items-center gap-4 py-1.5 lg:flex-col lg:items-start lg:gap-3 lg:py-0" data-id="element-268" data-mp="1dcmnfbzmn6vh" data-mpi={index}>
                  <span className="relative z-10 flex h-[31px] w-[31px] shrink-0 items-center justify-center rounded-full border border-ember-light bg-ink font-tech text-[14px] font-semibold text-ember-light" data-id="element-269" data-mp="14bodkd2ic54z">
                    {index + 1}
                  </span>
                  <span data-id="element-270" data-mp="3hrf0k9t5ccx0">
                    <span className="block font-display text-[1.3rem] leading-[1.15] lg:text-[1.2rem]" data-id="element-271" data-mp="3hqwtei4y4eab">
                      {step.title}
                    </span>
                    {step.hint && <span className="mt-1 block text-[0.86rem] leading-snug text-cream/70" data-id="element-272" data-mp="38tmjb03v6v6z">
                        {step.hint}
                      </span>}
                  </span>
                </li>)}
            </ol>
          </div>
        </div>

        <p className="mt-8 text-center font-display text-[1.5rem] leading-tight text-ink sm:mt-10 sm:text-[2rem]" data-id="element-273" data-mp="9c4r2gmxg5f7">
          <span className="border-b-2 border-ember pb-1 [box-decoration-break:clone]" data-id="element-274" data-mp="3ri1cnu1nmlay">
            The base design is ready. Verify and adapt it for each client’s site.
          </span>
        </p>
      </div>
    </section>;
}